import ForgotPasswordConfirmationComponent from '@/views/ForgotPasswordConfirmation.vue';
import RouteNames from '../constants/route-names';

const forgotPasswordConfirmationRoute = {
  component: ForgotPasswordConfirmationComponent,
  name: RouteNames.ForgotPasswordConfirmation,
  path: '/forgot-password/confirmation',
};

export default forgotPasswordConfirmationRoute;
